<script>
import options from "./ChatFeedbackReview.options"
export default options
</script>

<template>
    <div class="nyk-chat-feedback-review">
        <span v-if="feedbackApiMessage()" class="nyk-chat-feedback-review__final-message" v-html="feedbackApiMessage()"></span>
        <div class="nyk-chat-feedback-review__review-message">
            <span class="nyk-chat-feedback-review__heading">{{ getLabel('reviewFinalMessageHeading') }}</span>
            <span class="nyk-chat-feedback-review__sub-heading" v-html="getLabel('reviewFinalNegativeMessageSubheadingHTML')" v-if="feedbackPayloadNegative"></span>
            <span class="nyk-chat-feedback-review__sub-heading" v-html="getLabel('reviewFinalPositiveMessageSubheadingHTML')" v-else></span>
        </div>
    </div>
</template>